import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { config } from '../../../../config/config';
import { CreatePlaceCommand } from '../../../commands/hub/place/create.place.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { BaseComponent } from '../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../common/components/success.wrap/success.wrap.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { CanComponentDeactivate } from '../../../common/guards/index';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { HubApiService } from '../../../services/hub.api.service';
import { EditPlaceCategoryModalActions } from '../../hub/edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../hub/edit.place.category.modal/edit.place.category.modal.component';
import { HubPlace } from '../../../models/hub/hub.place';

@Component({
  selector: 'ig-visitor-create-place',
  templateUrl: './create.place.component.html',
  styleUrls: ['./create.place.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorCreatePlaceComponent extends BaseComponent implements OnInit, CanComponentDeactivate {
  public hubName: string;
  public selectedImageData: string;
  public command = new CreatePlaceCommand();
  public createPlaceForm: FormGroup;
  public toggles: HubVisitorFeatureToggle;
  public resizeImageTemp = null;
  public backUrl = routeConfigs.visitor.placeCalendar;
  public categoryText = '';
  public isEmailGDPRAllowed = false;
  public isImageChanged = false;
  public hasCopyrights = false;
  public imageUploaderLabel2 = 'Please upload images in JPG, PNG or WEBP format. Landscape images recommended';
  @ViewChild('description') public descriptionArea: ElementRef;
  @ViewChild('createPlaceSuccess') public successWrap: SuccessWrapComponent;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private imageService: ImageService,
    private hubApiService: HubApiService,
    private visitorApiService: VisitorApiService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.command.defaultImage = config.defaultImageUrl;
    this.createPlaceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      address: [null, [Validators.required]],
      website: [null, []],
      category: [null, []],
      ownerEmail: [null, []],
    });

    this.visitorApiService.getPlaceCategoryToggle(this.hubName).subscribe((toggleCommand) => {
      this.toggles = toggleCommand.toggle;
    });

    this.activatedRoute.url.subscribe((data) => {
      const submitPath = routeConfigs.submit.place.path.replace(':hubName/', '');
      if (data.any((x) => x.path.includes(submitPath))) {
        this.backUrl = routeConfigs.tripPlanner.trip;
      }
    });
  }

  public async onImageChange(file) {
    if (file) {
      this.resizeImageTemp = await this.imageService.compressImageFileToBase64(file, config.compressImgWidth);
      this.isImageChanged = true;
    }
  }

  public async createPlace(event: ButtonTriggerEvent) {
    let { hubName } = this.allRouteParams;
    this.command.isHubCreated = false;

    // if (this.command.image) {
    //     const imageBase64 = await this.imageService.getBase64ByImageFile(this.command.image);
    //     this.command.imageLink = imageBase64;
    //     this.command.image = null;
    // }

    // image uploaded
    if (this.resizeImageTemp) {
      const res = await this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp);
      if (res.success) {
        this.command.image = null;
        this.command.imageLink = res.url;
      }
    }

    this.visitorApiService
      .createPlace(hubName, this.command)
      .finally(event.complete)
      .subscribe(() => {
        this.successWrap.success();
        this.command = new CreatePlaceCommand();
        this.createPlaceForm.markAsPristine();
        this.selectedImageData = null;
        this.command.category = '';
        this.categoryText = '';
        this.descriptionArea.nativeElement.style.height = '40px';
        this.resizeImageTemp = null;
        this.isImageChanged = false;
        this.hasCopyrights = false;
      });
  }

  public descriptionChange() {
    this.descriptionArea.nativeElement.style.height =
      Math.min(this.descriptionArea.nativeElement.scrollHeight, 500) + 'px';
  }

  public goBack() {
    this.router.navigateByUrl(
      getRouteUrl(this.backUrl, {
        hubName: this.hubName,
        category: 'all',
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
  }

  public showEditCategoryModal() {
    let actions = <EditPlaceCategoryModalActions>{
      confirm: (event: ButtonTriggerEvent, category) => {
        this.categoryText = category.categoryText;
        this.command.category = category.category;
      },
    };

    this.modalService.show({
      component: EditPlaceCategoryModalComponent,
      providers: [
        { provide: EditPlaceCategoryModalActions, useValue: actions },
        {
          provide: HubPlace,
          useValue: {
            hubName: this.hubName,
            categoryText: this.categoryText,
            category: this.command.category,
            categoryList: this.command.category ? this.command.category.split(', ') : [],
          } as HubPlace,
        },
      ],
      panelClass: 'width-modal-70p',
    });
  }

  public canDeactivate() {
    if (this.createPlaceForm.pristine) {
      return Observable.of(true);
    }

    let allowNavigate = new Subject<boolean>();

    this.modalService.showUnSaveWarning({ allowNavigate });

    return allowNavigate;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/create.place/create.place.component.ts